(function () {
  'use strict';

  if (window.__HYDROGEN_INFO_TEST__) return;
  window.__HYDROGEN_INFO_TEST__ = true;

  const style = document.createElement('style');

  style.innerHTML = `
  
    .hy-info-wrap{
      margin:20px 0;
    }

    .hy-tabs{
      display:flex;
      gap:10px;
      margin-bottom:14px;
      justify-content:center;
      margin-top: 14px;
    }

    .bp-pdp-root .hy-tab-btn{
      flex:1;
      height:30px;
      border:2px solid #6d2b33;
      border-radius:40px;
      background:#fff;
      color:#6d2b33;
      font-size:12px;
      font-weight:400;
      cursor:pointer;
      width:auto;
      max-width:fit-content;
      line-height:19.04px;
      padding:0 14px;
    }

    .hy-tab-btn.active{
      background:#6d2b33;
      color:#fff;
    }

    .hy-box{
      display:none;
      background:#fff;
      border-radius:24px;
      padding:16px;
       box-shadow: 0px 0px 28px 0px #00000059;
      position:relative;
      margin-top:18px;
    }

    .hy-box.take-it-main-box{
      padding:20px;
    }

    .hy-box.active{
      display:block;
    }

    .hy-title{
      font-family: Instrument Sans;
      font-weight: 400;
      font-size: 18px;
      line-height: 23.4px;
      letter-spacing: 0px;
      text-align: center;
      vertical-align: middle;
      text-transform: capitalize;
      color: #BD3D44;
      margin-bottom: 5px;
    }

    .hy-title b{
      font-weight:700;
    }

    .hy-title.take-it-box{
      font-size:12px;
    }

    .hy-title.take-it-box b{
      font-size:18px;
    }

    .hy-main-image{
      width:100%;
      margin-top:16px;
      display:block;
    }

    .hy-daily{
      margin-top:18px;
      border:1px solid #eee;
      border-radius:16px;
      padding:17px 25px;
      display:flex;
      gap:12px;
      align-items:center;
    }

    .hy-pill{
      width:56px;
      height:56px;
      border-radius:50%;
      background:radial-gradient(circle,#bfc3c6,#76797c);
      flex-shrink:0;
      overflow:hidden;
    }

    .hy-pill img{
      width:100%;
      height:100%;
      object-fit:cover;
      display:block;
    }

    .hy-daily h4{
      font-family: Instrument Sans;
      font-weight: 700;
      font-size: 14px;
      line-height: 13.98px;
      letter-spacing: 0%;
      color: #BD3D44;
      margin-bottom: 0;
    }

    .hy-daily p{
      font-family:Instrument Sans;
      font-weight:400;
      font-size:12px;
      letter-spacing:normal;
      line-height:12.23px;
      color:#6B7280;
      margin-top:6px;
      margin-bottom:0;
    }

    .hy-card-inner{
      display:flex;
      gap:12px;
      margin-bottom:7px;
    }

    .hy-card{
      border:1px solid #5F0000;
      border-radius:14px;
      background:#FFE4E5;
      padding:14px;
      margin-bottom:13px;
    }
    
    .hy-card.middle-card{
			opacity: 0.5;
		}
		.hy-card.middle-card .opitonal-class{
			color: #551C25;
			font-family: Instrument Sans;
font-weight: 500;
font-style: Medium;
font-size: 7.63px;
line-height: 12.59px;
letter-spacing: 1.63px;
border: 0.5px solid #551C25;
    position: absolute;
    right: 30px;
    opacity: 1;
    padding: 0 5px;
    border-radius: 6px;
		}

    .hy-icon{
      width:48px;
      height:48px;
      border-radius:50%;
      background:#d54452;
      color:#fff;
      display:flex;
      align-items:center;
      justify-content:center;
      font-size:20px;
      flex-shrink:0;
      overflow:hidden;
    }

    .hy-icon img{
      width:100%;
      height:100%;
      object-fit:cover;
      display:block;
    }

    .hy-card h4{
      font-family: Instrument Sans;
      font-weight: 700;
      font-size: 14px;
      line-height: 23.11px;
      letter-spacing: 0px;
      color: #0F1419;
      margin-bottom: 0;
    }

    .hy-card p{
      font-family:Instrument Sans;
      font-weight:400;
      font-size:13px;
      line-height:16.43px;
      color:#0F1419;
      margin:0;
    }

    .hy-card p.hy-small{
      font-family:Instrument Sans;
      font-weight:500;
      font-size:10px;
      line-height:11.56px;
      letter-spacing:.22px;
      text-transform:uppercase;
      color:#6B7280;
      margin-top:4px;
    }

    .hy-card p.hy-time{
      font-family:Inter;
      font-weight:500;
      font-size:13px;
      line-height:17.33px;
      color:#0F1419;
      margin-top:2px;
    }

    .bp-pdp-root .hy-close{
      font-family:Instrument Sans;
      font-weight:600;
      font-size:12px;
      line-height:22.5px;
      letter-spacing:17%;
      text-decoration:underline;
      border:0;
      background:none;
      display:flex;
      justify-content:center;
      align-items:center;
      width:100%;
      margin-top:18px;
      cursor:pointer;
      color:#000;
    }

    /* =========================
       DESKTOP FIX
    ========================= */

    @media(min-width:769px){

      .hy-info-wrap{
        max-width:500px;
      }
      .hy-tabs{
      	justify-content: start;
      }

    }
     @media(max-width:749px){
     .hy-info-wrap{
      margin: 0px 0 20px;
    width: 100%;
    }
    .thumbnails-wrapper {
        margin: 0 2px 17px;
    }
    .product-single__media-group{
    	margin-bottom: 0;
    }
    .hy-box:before{
      content:'';
      position:absolute;
      top:-10px;
      width:22px;
      height:22px;
      background:#fff;
      transform:rotate(45deg);
    }

    .hy-box[data-content="how"]:before{
      left:120px;
    }

    .hy-box[data-content="when"]:before{
      right:120px;
    }
     }

  `;

  document.head.appendChild(style);

  const html = `
  
    <div class="hy-info-wrap">

      <div class="hy-tabs">

        <button class="hy-tab-btn"
          data-tab="how">
          ⓘ How to Use
        </button>

        <button class="hy-tab-btn"
          data-tab="when">
          ⓘ When to Take It
        </button>

      </div>

      <!-- HOW -->
      <div class="hy-box"
        data-content="how">

        <h2 class="hy-title">
          <b>90X More Potent</b> Than <br>
          Bottled Hydrogen Water
        </h2>

        <img
          class="hy-main-image"
          src="https://cdn.shopify.com/s/files/1/0750/1807/6373/files/Group_1_8b4a6e36-20a5-417e-a8af-5887f6016580.png?v=1779991554"
        >

        <div class="hy-daily">

          <div class="hy-pill">
            <img src='https://cdn.shopify.com/s/files/1/0750/1807/6373/files/Frame_2147233473.png?v=1779906495' />
          </div>

          <div>

            <h4>
              Use Daily: Take 1–2 tablets at a time,
              up to 6 tablets per day.
            </h4>

            <p>
              Use daily for 3 months to maximize
              performance and benefits.
            </p>

          </div>

        </div>

        <button class="hy-close">
          CLOSE
        </button>

      </div>

      <!-- WHEN -->
      <div class="hy-box take-it-main-box"
        data-content="when">

        <h2 class="hy-title take-it-box">
          <b>When To Take It</b> <br>
          Take 2–3X A Day To Get The Best Results
        </h2>

        <div class="hy-card">

          <div class="hy-card-inner">

            <div class="hy-icon">
              <img src='https://cdn.shopify.com/s/files/1/0750/1807/6373/files/Container.png?v=1779906495' />
            </div>

            <div>

              <h4>Morning Boost</h4>

              <p>
                Start your day with clarity,
                hydration and focus.
              </p>

            </div>

          </div>

          <p class="hy-small">
            BEST TIME
          </p>

          <p class="hy-time">
            After waking up and before breakfast
          </p>

        </div>

        <div class="hy-card middle-card">

          <div class="hy-card-inner">

            <div class="hy-icon">
              <img src='https://cdn.shopify.com/s/files/1/0750/1807/6373/files/Container_1.png?v=1779906495' />
            </div>

            <div>

              <h4>Afternoon Reset</h4>

              <p>
                Boost energy and beat afternoon crashes
              </p>

            </div>
 <div class='opitonal-class'>
            OPITONAL
            </div>
          </div>

          <p class="hy-small">
            BEST TIME
          </p>

          <p class="hy-time">
            20–30 mins before lunch
          </p>

        </div>

        <div class="hy-card">

          <div class="hy-card-inner">

            <div class="hy-icon">
              <img src='https://cdn.shopify.com/s/files/1/0750/1807/6373/files/Container_2.png?v=1779906495' />
            </div>

            <div>

              <h4>Evening Recharge</h4>

              <p>
                Relax your body and support recovery.
              </p>

            </div>

          </div>

          <p class="hy-small">
            BEST TIME
          </p>

          <p class="hy-time">
            1-2 hours before sleeping
          </p>

        </div>

        <button class="hy-close">
          CLOSE
        </button>

      </div>

    </div>

  `;

  function init() {

    const isMobile = window.innerWidth <= 768;

    let targets;

    if (isMobile) {

      targets = document.querySelectorAll(
        '.hero-title'
      );

    }

    else {

      targets = document.querySelectorAll(
        '.hero-title'
      );

    }

    if (!targets.length) return;

    targets.forEach(function (target) {

      const existing =
        target.parentNode.querySelector('.hy-info-wrap');

      if (existing) return;

      const div = document.createElement('div');

      div.innerHTML = html;

      const component = div.firstElementChild;

      if (isMobile) {

        target.insertAdjacentElement(
          'afterend',
          component
        );

      } else {

        target.insertAdjacentElement(
          'beforeend',
          component
        );

      }

      initTabs(component);

    });

  }

  function initTabs(wrapper) {

    const buttons =
      wrapper.querySelectorAll('.hy-tab-btn');

    const boxes =
      wrapper.querySelectorAll('.hy-box');

    const closes =
      wrapper.querySelectorAll('.hy-close');

    buttons.forEach(function (button) {

      button.addEventListener(
        'click',
        function (e) {

          e.preventDefault();
          e.stopPropagation();

          const tab =
            this.getAttribute('data-tab');

          buttons.forEach(function (btn) {
            btn.classList.remove('active');
          });

          boxes.forEach(function (box) {
            box.classList.remove('active');
          });

          this.classList.add('active');

          wrapper
            .querySelector(
              '[data-content="' + tab + '"]'
            )
            .classList.add('active');

        },
        true
      );

    });

    /* CLOSE */

    closes.forEach(function (closeBtn) {

      closeBtn.addEventListener(
        'click',
        function (e) {

          e.preventDefault();
          e.stopPropagation();

          boxes.forEach(function (box) {
            box.classList.remove('active');
          });

          buttons.forEach(function (btn) {
            btn.classList.remove('active');
          });

        },
        true
      );

    });

      /* CLOSE ON OUTSIDE CLICK */

    document.addEventListener(
      'click',
      function (e) {

        const activeBox =
          wrapper.querySelector('.hy-box.active');

        if (!activeBox) return;

        const clickedInside =
          wrapper.contains(e.target);

        if (!clickedInside) {

          boxes.forEach(function (box) {
            box.classList.remove('active');
          });

          buttons.forEach(function (btn) {
            btn.classList.remove('active');
          });

        }

      },
      true
    );
  }

  const observer = new MutationObserver(function () {

    if (
      document.querySelector('.product-single__title') ||
      document.querySelector('.product-single__meta')
    ) {

      observer.disconnect();

      init();

    }

  });

  observer.observe(document.body, {
    childList:true,
    subtree:true
  });

  init();

})();


